import type { CMSConfig } from '#types/config/components/cms'
import colors from '#core/design-system/colors.json'

export default {
  defaultLinksHoverColor: colors.grey['20']
} satisfies CMSConfig['richText']
